<template>
  <div class="the-top-bar">
    <c-main-info />
    <c-login-selector />
  </div>
</template>

<script>
import CLoginSelector from '../ui/CLoginSelector.vue'
import CMainInfo from '../ui/CMainInfo.vue'

export default {
  name: 'TheTopBar',
  components: {
    CLoginSelector,
    CMainInfo
  }
}
</script>

<style scoped lang="scss">
.the-top-bar {
  display: flex;
  .c-login-selector {
    display: flex;
    align-items: center;
  }
  .c-main-info {
    width: 100%;
  }
}
</style>
